import { useTranslation } from 'react-i18next';

const FormToggle = ({
  label,
  description,
  name,
  checked,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <label
      htmlFor={name}
      className={`flex items-center justify-between p-4 rounded-lg transition-colors cursor-pointer ${
        disabled
          ? 'bg-neutral-100 dark:bg-neutral-800/50 cursor-not-allowed'
          : 'bg-neutral-50 dark:bg-neutral-800 hover:bg-neutral-100 dark:hover:bg-neutral-700/60'
      }`}
    >
      <div className="flex-1 pr-4">
        <p
          className={`font-semibold text-neutral-800 dark:text-neutral-200 ${
            disabled ? 'text-neutral-400 dark:text-neutral-500' : ''
          }`}
        >
          {t(label)}
        </p>
        <p
          className={`text-sm text-neutral-500 dark:text-neutral-400 ${
            disabled ? 'text-neutral-400 dark:text-neutral-500' : ''
          }`}
        >
          {t(description)}
        </p>
      </div>
      <div
        className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors ${
          checked ? 'bg-primary' : 'bg-neutral-300 dark:bg-neutral-600'
        } ${disabled ? 'opacity-50' : ''}`}
      >
        <span
          className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${
            checked ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
        <input
          id={name}
          name={name}
          type="checkbox"
          className="absolute w-full h-full opacity-0 cursor-pointer"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </label>
  );
};

export default FormToggle;
